var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1579 5.78931V9.99983M1 5.78931V14.3459C1 15.5106 2.63874 16.2028 5.91537 17.5864C7.23158 18.143 7.89011 18.4209 8.57895 18.4209V9.45667M11.1053 15.8946C11.1053 15.8946 11.8421 15.8946 12.5789 17.5788C12.5789 17.5788 14.92 13.3683 17 12.5261",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52632 9.99991L5.21053 10.842M12.7895 3.26307L4.36842 7.47359M5.48505 8.05549L3.02526 6.86559C1.67537 6.21212 1 5.88538 1 5.36833C1 4.85128 1.67537 4.52454 3.02526 3.87107L5.48421 2.68117C7.00421 1.94602 7.76211 1.57886 8.57895 1.57886C9.39579 1.57886 10.1545 1.94602 11.6728 2.68117L14.1326 3.87107C15.4825 4.52454 16.1579 4.85128 16.1579 5.36833C16.1579 5.88538 15.4825 6.21212 14.1326 6.86559L11.6737 8.05549C10.1537 8.79065 9.39579 9.1578 8.57895 9.1578C7.76211 9.1578 7.00337 8.79065 5.48505 8.05549Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.c37ec7c77967026df4d738055d489774.svg";
export { ForwardRef as ReactComponent };